export type ClipboardCopyResult = 'copied' | 'unsupported' | 'error';

export async function copyTextToClipboard(value: string): Promise<ClipboardCopyResult> {
  if (typeof navigator.clipboard?.writeText !== 'function') {
    return 'unsupported';
  }

  try {
    await navigator.clipboard.writeText(value);
    return 'copied';
  } catch {
    return 'error';
  }
}
